export const STUB_COMMENT_ID = "stubCommentId";
